export default __webpack_public_path__ + "static/media/delievers16.430c3fb3.jpg";